<template>
  <div class="app">
    <el-container v-if="!state.isLogin" class="container">
		<div class="ylzz" @click="showClick" v-if="!showLeft">料行家</div>
      <el-aside width="200px" v-if="showLeft">
        <div class="waymon_aside">
            <div class="waymon_title" @click="showClick" v-if="showLeft">料行家</div>
        </div>
        <el-menu
            v-if="state.menus"
            :default-opends="['1']"
            background-color="#222832"
            text-color="#fff"
            active-text-color="#1296db"
            :router="true"
            :unique-opened="true"
            :default-active="state.currentPath"
        >
          <el-sub-menu v-for="(item,index) in state.menus" :index="index">
            <template #title>
              <component :is="item.icon" style="width: 22px;height: 22px; margin-right: 5px"></component>
              <span>{{ item.title }}</span>
            </template>
            <el-menu-item-group v-for="value in item.subs">
              <el-menu-item :index="value.index" :title="value.title" :route="value.route">
                {{ value.title }}
              </el-menu-item>
            </el-menu-item-group>
          </el-sub-menu>
        </el-menu>
      </el-aside>
	  
      <el-container v-if="!state.isLogin">
        <el-header height="80px">
          <el-row>
            <el-col :span="18">
                <div class="waymon_header_left" :class="{'waymon_headerNew':!showLeft}">
                  <el-page-header @back="onBack">
                    <template #icon>
                      <el-icon size="20" color="#000000"><Back /></el-icon>
                    </template>
                    <template #title>
                      <span style="color: black">返回</span>
                    </template>
                    <template #content>
                      <span class="text-large font-600 mr-3"> {{state.title}} </span>
                    </template>
                  </el-page-header>
                </div>
            </el-col>
            <el-col :span="6">
              <el-dropdown style="float: right;padding-right:15px;">
                  <span>
                    <el-row>
                      <el-col :span="20"><div class="waymon_detail">{{state.admin.nick_name}}</div></el-col>
                      <el-col :span="4"><img class="waymon_icon" src="../src/assets/set.png"></el-col>
                    </el-row>
                  </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item :icon="Edit" @click="onPassword">修改密码</el-dropdown-item>
                    <el-dropdown-item :icon="SwitchButton" @click="onOut">退出</el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </el-col>
          </el-row>
        </el-header>
         <el-main v-if="!state.isLogin">
          <router-view v-if="isRouterActive" v-slot="{ Component }">
            <keep-alive>
              <component :is="Component" :key="$route.name" v-if="$route.meta.keepAlive"/>
            </keep-alive>
            <component :is="Component" :key="$route.name" v-if="!$route.meta.keepAlive"/>
          </router-view>
        </el-main>
      </el-container>
    </el-container>
    <!-- 登录 -->
    <el-container v-else class="container">
      <router-view/>
    </el-container>
  </div>
  <el-backtop/>
</template>
<script setup>
import { ref, reactive, nextTick, provide, onMounted } from 'vue'
import { useStore } from 'vuex'
import {Edit,SwitchButton} from '@element-plus/icons-vue'
import { ElNotification } from 'element-plus'
import { removeSession } from './utils/util.js'
import {AdminMenu} from "@/api/admin";
import router from "@/router";
const store = useStore()
const isRouterActive = ref(true)
const showLeft = ref(true)
const showMore = ref(true)
const state = reactive({
  isLogin: false,
  isBack: false,
  title: '首页',
  admin: {},
  menus: [],
  indexs: [],
  currentPath: 'Home',
})
onMounted(() => {
	const screenWidth = ref(document.body.clientWidth);
	if(screenWidth.value<500){
		showLeft.value = false
		showMore.value = false
	}else{
		showLeft.value = true
		showMore.value = true
	}
	
  const admin = store.getters.admin
  if (!admin) {
    state.isLogin = true
    router.push({ path: '/Login' })
  } else {
    state.isLogin = false
    state.admin = admin
    //
    ElNotification({
      title: '欢迎' + admin.nick_name + '登录!',
      dangerouslyUseHTMLString: true,
      message: '登录时间 : ' + admin.last_time + '</br>' + '登录ip : ' + admin.last_ip + '</br>' + '登录次数 : ' + admin.logins,
      position: 'bottom-right',
    })
    //
    AdminMenu({
      role_id: admin.role_id
    }).then((res)=>{
       state.menus = res.data
    })
  }
  router.afterEach((to) => {
    const { title } = to.meta
    state.title = title
  })
})
const showClick = () =>{
	showLeft.value = !showLeft.value
}
const onBack = () => {
  router.go(-1)
}
const reload = () => {
  isRouterActive.value = false
  nextTick(() => {
    isRouterActive.value = true
  })
}
provide('reload', {
  reload
})
const onPassword = () => {
    router.push({
      path: '/AdminEdit',
      query: { id: state.admin.id }
    })
}
const onOut = () => {
  removeSession('admin')
  state.isLogin = true
  router.push({ path: '/Login' })
}
// 解决ERROR ResizeObserver loop completed with undelivered notifications.
// 重写ResizeObserver的构造函数，并在其中定义并调用防抖函数
window.ResizeObserver = class ResizeObserver extends window.ResizeObserver {
  constructor(callback) {
    let timer = null;
    const debouncedCallback = function () {
      let context = this;
      let args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, 16);
    };
    super(debouncedCallback);
  }
};
</script>
<style>
@import "css/waymon.css";
</style>
<style scoped>
	.container{
		position: relative;
	}
	.ylzz{
		position: absolute;
		top: 20px;
		left: 0;
		color: #000;
		width: 40px;
		padding: 0 15px;
		z-index: 100000;
		font-weight: 700;
	}
	.waymon_headerNew{
		padding-left: 50px;
	}
	.el-tooltip__trigger:focus {
	    outline: none;
	}
</style>
